export default "__VITE_ASSET__d15980b8__"